import { createContext } from 'react'

// The project forms opened inside a tension during a meeting (#123). Same
// shape and same reason as NextStepFormsContext: the button sits in the
// composer, the forms belong to the activity stream, and the two are siblings.
export interface TaskFormsState {
  forms: number[]
  addForm(): void
  removeForm(key: number): void
}

export const TaskFormsContext = createContext<TaskFormsState | undefined>(
  undefined
)
